import { OnInit, Component, Input, OnDestroy } from "@angular/core";
import { select } from "@angular-redux/store";
import { Observable, Subject } from "rxjs";
import { TransportOrder } from "../../../../../pb-screen/models/transport-order/transport-order.interface";
import { ToScreenService } from "../../../../../pb-screen/services/to-screen.service";
import { takeUntil } from "rxjs/operators";
import { ApplicationUser } from "../../../../../pb-screen/models/application.user.interface";

@Component({
    moduleId: module.id,
    selector: 'to-genral-details',
    templateUrl: './to-general-details.component.html',
})

export class ToGeneralDetailsComponent implements OnInit, OnDestroy {

    @select('applicationUser') public applicationUser$: Observable<ApplicationUser>;
    public enableAutocomplete: boolean = false;

    @Input() public transportorder: TransportOrder;
    @Input() selectedTransportOrder: TransportOrder ; 
    destroy$ = new Subject();
    
    constructor(private readonly toService : ToScreenService) {}
    
    ngOnInit(): void {

        this.applicationUser$.pipe(takeUntil(this.destroy$)).subscribe((applicationUser: ApplicationUser) => {
            if (applicationUser) {
              this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
            }
          });
      
    }

    
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

}